import React from 'react';
import defaultChatImage from '../../assets/img/communication.svg';

const DefaultChat = ({message,img}) => {
    return (
        <div className='default-chat--container '>
            <img className="" src={img?img:defaultChatImage} alt="Data Not Found" />
            <h4 className="mt-5">{message}</h4>
        </div>
    );
};

export default DefaultChat;